import { OvlAddDialog } from "../../../../../../_ovlclient/src/global/globals"
import { CompImagePopup } from "./imagepopup"

export const GENImagePopup_Init = () => {
  OvlAddDialog(CompImagePopup, "GENImagePopup")
}
